import GETTERS from './getters'
import MUTATIONS from './mutations'
import ACTIONS from './actions'
export default {
  namespaced: true,
  state: {
    isOpen: false,
    isStopScroll: false
  },
  mutations: MUTATIONS,
  getters: GETTERS,
  actions: ACTIONS
}



// WEBPACK FOOTER //
// ./src/store/modules/ui/index.js